import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

export const fetchSalesInvoiceRegisters = async (query) => {
  const { data } = await apiClient.get('/document-registers/sales-invoices', {
    params: query.queryKey[1],
  });
  return data;
};

export const useGetSalesInvoiceRegistersHandler = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const { salesInvoiceRegister } = useTranslatedMessages();
  const messages = salesInvoiceRegister?.handlers || {};
  const [registers, setRegisters] = useState([]);
  const [totalDocuments, setTotalDocuments] = useState(0);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['sales-invoice-register', { ...searchQuery }],
    queryFn: fetchSalesInvoiceRegisters,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    cacheTime: 0,
    retry: 3,
  });

  useEffect(() => {
    if (fetchedData) {
      setRegisters(fetchedData.content ?? []);
      setTotalDocuments(fetchedData.total_elements ?? 0);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      const fallbackMessage = messages.load_error ?? 'Failed to load sales invoice register entries';
      if (error instanceof AxiosError) {
        dispatch(
          showSnackbar({
            message: error.response?.data?.message ?? error.message ?? fallbackMessage,
            severity: 'error',
          }),
        );
      } else {
        dispatch(showSnackbar({ message: error?.message ?? fallbackMessage, severity: 'error' }));
      }
    }
  }, [dispatch, error, isError, messages.load_error]);

  return {
    registers,
    totalDocuments,
    isLoading,
  };
};
